import type { UnizoFeatureFlagKey } from "@shared-domain/unizo/featureFlags";
import type { Category, GuideFlagCondition } from "./types";

/** 条件を満たすか（書いたフラグがすべてその値か）。条件が無ければ出す。 */
export const matchesGuideFlags = (
  when: GuideFlagCondition | undefined,
  isOn: (key: UnizoFeatureFlagKey) => boolean,
): boolean =>
  !when ||
  (Object.entries(when) as [UnizoFeatureFlagKey, boolean][]).every(
    ([key, value]) => isOn(key) === value,
  );

/**
 * PRODUCT_DEV-795: テナントの機能フラグに合わせて、使い方ガイドのカテゴリ・記事・ブロックを絞る。
 *
 * フラグが OFF のテナントには、その機能の記事や手順を出さない（使えない機能の説明を読ませない）。
 * 記事が 1 本も残らないカテゴリは見出しごと落とす。
 */
export const filterGuideByFlags = (
  data: Category[],
  isOn: (key: UnizoFeatureFlagKey) => boolean,
): Category[] =>
  data
    .filter((c) => matchesGuideFlags(c.when, isOn))
    .map((c) => ({
      ...c,
      title: c.titleWhen?.find((t) => matchesGuideFlags(t.when, isOn))?.title ?? c.title,
      articles: c.articles
        .filter((a) => matchesGuideFlags(a.when, isOn))
        .map((a) => {
          const alt = a.titleWhen?.find((t) => matchesGuideFlags(t.when, isOn));
          return {
            ...a,
            title: alt?.title ?? a.title,
            description: alt?.description ?? a.description,
            blocks: a.blocks.filter((b) => matchesGuideFlags(b.when, isOn)),
          };
        }),
    }))
    .filter((c) => c.articles.length > 0);
